export default {"src":"/org/_next/static/media/arrow-up.d841ff5d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};